import { useQuery } from '@apollo/client'
import productFeaturesGetQuery from '@queries/productFeaturesGetQuery'
import { ApiHookResultWithReload } from '@typings/ApiHooks'
import { ProductFeature } from '@typings/entities/ProductFeature'

export const useLoadProductFeatures = (selectedOrganisation?: string): ApiHookResultWithReload<ProductFeature[]> => {
  const {
    data,
    loading: isLoading,
    error,
    refetch: reload,
  } = useQuery(productFeaturesGetQuery, {
    variables: {
      criteria: { organisations: { eq: selectedOrganisation }, active: true },
    },
    fetchPolicy: 'no-cache',
    skip: !selectedOrganisation,
  })
  return {
    data: data?.productFeaturesGet?.results,
    isLoading,
    error,
    reload,
  }
}
